<template>
  <div class="content">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
    >
      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
      >
      <div class="card-title">
       <span >订单编号：{{item.orderSn}}</span>
       <span style="color: #ee0a24">{{getRefunName(item.afterSaleApplyStatus)}}</span>
       </div>
        <div class="card">
          <img
            :src="item.productPictureUrl"
            alt=""
          />
          <div>
            <p class="van-multi-ellipsis--l2">
              {{item.title}}
            </p>
            <p>数量：{{item.productQuantity}}</p>
          </div>
        </div>
        <div class="card-btn">
          <div >
            <span v-if="item.dateHasPassed">该商品已超过售后期</span>
          </div>
          <div>
                <!-- // 售后类型,可用值:0 (待处理) ,1 (等待买家退货) ,2 (退货中) ,3 (退款中) ,4 (已完成) ,5 (已拒绝) ,6 (已撤销) -->
            <van-button v-if="!item.afterSaleId && item.refundable" round size="small" :disabled="item.dateHasPassed " @click="goDispose(item.orderItemId,item.maxRefundAmount,item.status)">申请售后</van-button>
            <van-button v-if="[5,6].includes(item.afterSaleApplyStatus)" round size="small" :disabled="item.dateHasPassed " @click="goDispose(item.orderItemId,item.maxRefundAmount,item.status)">重新申请</van-button>
            <van-button  v-if="item.afterSaleId" round size="small"  @click="goDetail(item.afterSaleId)">查看详情</van-button>
          </div>
        </div>
        <!-- <div class="line"></div>
        <div class="card">
          <img
            src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=488976211,2991240850&fm=11&gp=0.jpg"
            alt=""
          />
          <div>
            <p class="van-multi-ellipsis--l2">
              产品名称产品名称产品名称产品名称产品名称产品名称产品名称产品名称产品名称产品名称产品名称产品名称
            </p>
            <p>数量：1</p>
          </div>
        </div>

        <div class="card-btn">
          <span>该商品已超过售后期</span>
          <van-button round size="small">申请售后</van-button>
        </div> -->
      </div>
    </van-list>
  </div>
</template>

<script>
import { productList, recordList, processingList } from '@/api/after-sale'
export default {
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      query: {
        current: 1,
        size: 10,
        keyword:undefined
      },
    }
  },
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.loading = true
      productList(this.query).then(({ data }) => {
        if (data.code === 200) {
          const total = data.data.total
          this.list = this.list.concat(data.data.records)
          // 加载状态结束

          this.query.current++
          this.loading = false
          console.log('this.list', this.list)
          // 数据全部加载完成
          if (this.list.length >= total) {
            this.finished = true
          }

          // if (this.list.length === 0) {
          //   this.finishedText = ''
          // }
        }
      })
    },
    // 售后类型,可用值:0 (待处理) ,1 (等待买家退货) ,2 (退货中) ,3 (退款中) ,4 (已完成) ,5 (已拒绝) ,6 (已撤销)
    getRefunName(num){
        switch (num){
            case 0: return "待处理"
            case 1: return "等待买家退货"
            case 2: return "退货中"
            case 3: return "退款中"
            case 4: return "已完成"
            case 5: return "已拒绝"
            case 6: return "已撤销"
        }
    },
      goDetail(id) {
      this.$router.push({
        path: '/after-sale/detail',
        query: { id: id },
      })
    },
    goDispose(orderItemId,returnAmount,status){
      this.$router.push({
        path:'/after-sale/apply',query:{orderItemId:orderItemId,returnAmount:returnAmount,status:status}
      })
    },
  },

}
</script>

<style lang="less" scoped>
.list {
  background: #fff;
  // margin-top: 10px;
  border-top: 10px solid rgb(246, 246, 246);
  padding: 10px;
  .card-title {
    padding: 0px 15px 10px 0px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .card {
    margin-top: 10px;
    display: flex;
    p {
      font-size: 14px;
      margin: 0 0 10px 0;
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
  .card-status {
    min-height: 55px;
    justify-content: space-between;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    font-size: 14px;
    align-items: center;
    padding: 5px 15px;
    background: rgb(246, 246, 246);
    color: #848484;
    p {
      margin: 2.5px 0;
    }
    /deep/.van-icon {
      color: #848484;
      font-size: 20px;
    }
    .status {
      margin-right: 15px;
    }
  }
  .card-btn {
    display: flex;
    justify-content: space-between;
    padding: 10px 5px 0px 0px;
    /deep/ .van-button--round {
      margin-right: 15px;
      border-color: #ee0a24;
      /deep/.van-button__text {
        color: #ee0a24;
      }
    }
    span {
      font-size: 12px;
      color: #848484;
    }
  }
  .line {
    margin: 10px 15px 10px 15px;
    height: 1px;
    background: rgb(246, 246, 246);
  }
}

</style>